export default "__VITE_ASSET__8f584371__"